import {
  Container,
  ImageList,
  ImageListItem,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const useStyle = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(10),
    height: "100vh",
    position: "sticky",
    top: 0,
    display: "block",
    [theme.breakpoints.down("md")]: {
      display: "none",
      backgroundColor: "black",
      color: "white",
    },
  },
  title: {
    fontSize: 16,
    color: "#151313",
    fontWeight: "bold",
  },
  right: {
    paddingTop: theme.spacing(10),
    margin: "5px",
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  img: {
    width: 140,
    height: 110,
  },
}));

const RightBar = () => {
  const classes = useStyle();

  const { t, i18n } = useTranslation();

  return (
    <div className="Rightbar">
      <Container className={classes.container}>
        <Typography className={classes.title} gutterBottom>
          {t("gallery")}
        </Typography>
        <ImageList rowHeight={100} style={{ marginBottom: 20 }} cols={2}>
          <ImageListItem>
            <Link to="/app">
              <img
                src="https://previews.123rf.com/images/enterline/enterline1501/enterline150100029/35292712-la-palabra-apps-escritas-en-tipograf%C3%ADa-de-madera-.jpg"
                alt="Aplicaciones"
                className={classes.img}
              />
            </Link>
          </ImageListItem>
          <ImageListItem>
            <Link to="/games">
              <img
                src="https://previews.123rf.com/images/enterline/enterline1501/enterline150100049/35347451-la-palabra-juegos-escritas-en-tipograf%C3%ADa-de-madera-.jpg"
                alt=""
                className={classes.img}
              />
            </Link>
          </ImageListItem>
          <ImageListItem>
            <Link to="/serie">
              <img
                src="https://previews.123rf.com/images/enterline/enterline1403/enterline140300025/26435384-la-palabra-serie-escrito-en-tipo-de-tipograf%C3%ADa-de-%C3%A9poca.jpg"
                alt=""
                className={classes.img}
              />
            </Link>
          </ImageListItem>
          <ImageListItem>
            <Link to="/movies">
              <img
                src="https://c8.alamy.com/compes/ek8g4w/la-palabra-peliculas-tema-escrito-en-vintage-manchadas-de-tinta-tipografia-de-madera-sobre-un-fondo-de-grano-de-madera-ek8g4w.jpg"
                alt=""
                className={classes.img}
              />
            </Link>
          </ImageListItem>
        </ImageList>
        <Typography className={classes.title} gutterBottom>
          {t("about-us")}
        </Typography>
        <Typography gutterBottom>
          <p className={classes.about}>{t("tabout")}</p>
        </Typography>
      </Container>
      <Typography className={classes.right}>
        <Typography className={classes.title} gutterBottom>
          SOBRE NOSOTROS
        </Typography>
        <Typography gutterBottom>
          <p className={classes.about}>
            Somos un sitio web pensado para brindarte el mayor entretenimiento y
            comodidad, uniendo en una misma plataforma, links totalmente
            gratuitos de pelis,juegos,apps y mas para que hagas tus días más
            divertidos.
          </p>
        </Typography>
      </Typography>
    </div>
  );
};

export default RightBar;
